<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wkIssI/tc-custom/9781467462471.jpg?1737196001647" alt="This image is the cover for the book The Book of Jeremiah, New International Commentary on the Old Testament (NICOT)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Book of Jeremiah, New International Commentary on the Old Testament (NICOT)
      </h1>
      <p class="bookDescription body article font2">
        <p>Of the Major Prophets, Jeremiah is perhaps the least straightforward. It is variously comprised of stories about the prophet Jeremiah, exchanges between Jeremiah and Yahweh, and messages directly from Yahweh—meaning a consciousness of form is essential to the understanding of its content. At times it is written in poetry, resembling Isaiah, while at other times it is written in prose, more similar to Ezekiel. And it is without doubt the darkest and most threatening of the Major Prophets, inviting comparisons to Amos and Hosea. </p><p>John Goldingay, a widely respected biblical scholar who has written extensively on the entire Old Testament, navigates these complexities in the same spirit as other volumes of the New International Commentary on the Old Testament series—rooted in Jeremiah’s historical context but with an eye always trained on its meaning and use as Christian Scripture. After a thorough introduction that explores matters of background, composition, and theology, Goldingay provides an original translation and verse-by-verse commentary of all fifty-two chapters, making this an authoritative and indispensable reference for scholars and pastors as they engage with Jeremiah from a contemporary Christian standpoint.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Goldingay
      </h2>
      
      <p class="authorDescription body article"><B>John Goldingay</B> is David Allan Hubbard Professor Emeritus of Old Testament at Fuller Seminary. &#160; </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21aeb478